import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../'
import config from '../../config'
import Styles from './AboutBanner.css'

@CSSModules(Styles)
export default class AboutBanner extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <Link
        to={config.routes.about}
        title='Learn more'
      >
        <div styleName='flex'>
          <div styleName='img' />
          <div styleName='copy'>
            <div styleName='title'>
              Defund big tobacco
            </div>
            <div styleName='lede'>
              Built for investors who want to make a difference. Our unique dataset can help you ensure your money is making an impact.
            </div>
            <div styleName='button'>
              Learn more<LinkIcon />
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

